import { BaseNumberIdDataDto } from '../../../../classes/common';
export class FaqQuestionDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        Object.assign(this, initializer);
    }
}
